<template>
  <v-app id="app" :dark="$root.config.dark">
    <v-toolbar dense dark app :color="$root.colors.primary" :class="['unselectable']">
      <v-toolbar-side-icon v-if="$root.ready" @click="nav = !nav" />
      <v-toolbar-title v-text="config.siteTitle" />
      <v-spacer />
      <v-btn icon :href="$root.config.contacts.facebook" target="_blank" :title="lang.followUsOnFacebook">
        <v-icon>mdi-facebook</v-icon>
      </v-btn>
      <v-btn icon :href="`mailto:${$root.config.contacts.email}`" :title="lang.emailUs">
        <v-icon>mdi-email</v-icon>
      </v-btn>
      <v-btn icon to="/" :title="lang.start" :class="['hidden-md-and-down']">
        <v-icon>mdi-home</v-icon>
      </v-btn>
    </v-toolbar>
    <v-navigation-drawer v-if="$root.ready" app v-model="nav" :class="['unselectable']">
      <v-img :aspect-ratio="16/9" src="/static/images/nav-image.jpg" :class="['nav-image', 'text-xs-center']">
        <v-icon size="10em" :class="['mt-3', 'item-clickable']" @click="goToResource()" :title="lang.start">mdi-guitar-electric</v-icon>
      </v-img>
      <v-list dense>
        <template v-for="(item, index) in routes">
          <v-list-tile ripple v-if="!item.nested" :key="index" :to="item.path" :title="item.label">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-title v-html="item.label" />
          </v-list-tile>
          <v-list-group v-else :prepend-icon="item.icon" :value="$route.path.split('/')[1] && item.name.includes($route.path.split('/')[1])" :key="index">
            <template v-slot:activator>
              <v-list-tile ripple :title="item.label">
                <v-list-tile-title v-html="item.label" />
              </v-list-tile>
            </template>
            <template v-for="(nested, i) in item.nested" v-if="item.name !== 'alphanumeric'">
              <v-list-tile ripple :key="i" v-if="item.name === 'years'" :to="`/years/${nested}`" :title="nested">
                <v-list-tile-title v-html="nested" />
              </v-list-tile>
              <v-list-tile ripple :key="i" v-if="item.name === 'genres'" :to="`/genres/${nested.id}`" :title="nested.label">
                <v-list-tile-title v-html="nested.label" />
              </v-list-tile>
              <v-list-tile ripple :key="i" v-if="item.name === 'regions'" :to="`/regions/${nested.id}`" :title="nested.label.cyrillic">
                <v-list-tile-title v-html="nested.label.cyrillic" />
              </v-list-tile>
              <v-list-tile ripple :key="i" v-if="item.name === 'releases'" :to="`/releases/${nested}`" :title="nested">
                <v-list-tile-title v-html="nested" />
              </v-list-tile>
            </template>
            <template v-for="(a, b) in Object.keys(item.nested)" v-else-if="item.name === 'alphanumeric' && i === 'numbers'">
              <v-container grid-list-md text-xs-center :key="b" :class="['py-2', 'px-3']">
                <v-layout row wrap>
                  <v-flex v-for="(c, d) in item.nested[a]" :key="d" xs1 :class="['pa-0']">
                    <router-link :class="[$root.config.dark ? 'white--text' : 'black--text', 'font-weight-regular', 'block-element']" :to="`/alphanumeric/${c}`" v-html="c" :title="c" />
                  </v-flex>
                </v-layout>
              </v-container>
              <v-divider :key="`${b}-divider`" />
            </template>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-content>
      <v-container>
        <router-view v-if="$root.ready" />
      </v-container>
    </v-content>
    <v-footer app v-if="$root.ready" :class="['unselectable', 'py-4', 'elevation-24']">
      <v-btn icon flat @click="settings" :title="lang.settings">
        <v-icon :color="$root.colors.primary">settings</v-icon>
      </v-btn>
      <template v-for="(item, index) in footerItems">
        <v-btn :class="['hidden-md-and-down']" v-if="!item.url.includes('http') && !item.url.includes('@')" icon flat :key="index" :to="item.url" :title="item.hint">
          <v-icon :color="$root.colors.primary">{{ item.icon }}</v-icon>
        </v-btn>
        <v-btn v-else icon flat :key="index" :href="`${item.url.includes('@') ? 'mailto:' : ''}${item.url}`" :target="item.url.includes('@') ? '_self' : '_blank'" :title="item.hint">
          <v-icon :color="$root.colors.primary">{{ item.icon }}</v-icon>
        </v-btn>
      </template>
      <v-spacer />
      <span :class="['mr-3']">&copy; 2003 - {{ date.getFullYear() }} <span :class="['hidden-md-and-down']">{{ $root.config.siteTitle }}</span></span>
    </v-footer>
    <vc-social-bar v-if="$root.ready" :title="$root.config.siteTitle" :font-size="2.15" :services="services" color="#fff" position="right" bg-color="#202020" />
    <settings-dialog />
    <error-dialog />
    <loading-overlay />
  </v-app>
</template>
<script>
import lang from './helpers/lang'
import config from './helpers/config'
import services from './helpers/social-bar-services'
import events from './helpers/events'
import methods from './helpers/methods'
import footerItems from './helpers/footer-items'

import SettingsDialog from './components/settings-dialog'
import ErrorDialog from './components/error-dialog'
import LoadingOverlay from './components/loading-overlay'

export default {
  name: 'App',
  components: {
    ErrorDialog,
    SettingsDialog,
    LoadingOverlay
  },
  mixins: [
    methods
  ],
  data () {
    return {
      lang,
      config,
      date: new Date(),
      services,
      nav: true,
      routes: [],
      footerItems
    }
  },
  created () {
    this.$root.$on(events.ready, () => {
      this.createNav()
    })
  },
  methods: {
    /**
     * Emit the $root.settings event to display the settings dialog
     * @method settings
     * @return {void}
     */
    settings () {
      this.$root.$emit(events.settings, {
        show: true
      })
    },
    /**
     * Create the navigation entries from the routes
     * @method createNav
     * @return {void}
     */
    createNav () {
      const routes = this.$router.options.routes.filter(route => route.nav)
      routes.forEach(route => {
        if (route.nested) {
          switch (route.nested) {
            case 'alphanumeric':
              route.nested = this.$root.alphanumeric
              break
            case 'genres':
              route.nested = this.$root.genres
              break
            case 'years':
              route.nested = this.$root.years
              break
            case 'regions':
              route.nested = this.$root.regions
              break
            case 'releases':
              route.nested = this.$root.releases
              break
            default:
              route.nested = []
              break
          }
        }
      })
      this.routes = routes
    }
  }
}
</script>
<style>
html
{
  scroll-behavior: smooth;
}

*
{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body
{
  cursor: default;
}

.item-clickable
{
  cursor: pointer;
}

[hidden]
{
  display: none !important;
}

.responsive-image
{
  display: block;
  width: 100%;
}

.nav-image
{
  filter: brightness(164%) contrast(100%) sepia(0%) saturate(0%) hue-rotate(0deg) invert(100%) opacity(100%) grayscale(100%) blur(0px);
}

.nav-image .v-icon
{
  opacity: .2;
}

.unselectable
{
  user-select: none;
}

.v-navigation-drawer .v-list__group__header .v-icon
{
  color: rgba(0, 0, 0, .87) !important;
}

.v-navigation-drawer :not(.router-link-exact-active)
{
  text-decoration: none;
}

.block-element
{
  display: block;
  width: 100%;
}

.theme--dark .external-link,
.theme--dark .external-link *,
.theme--dark .v-list__group__header .v-icon,
.theme--dark .v-navigation-drawer .v-list__tile.v-list__tile--active,
.theme--dark .v-navigation-drawer .v-list__tile.v-list__tile--active
{
  color: #fff !important;
}

.theme--light .external-link,
.theme--light .external-link *,
.theme--light .v-navigation-drawer .v-list__tile.v-list__tile--active
{
  color: rgba(0, 0, 0, .87) !important;
}

.v-navigation-drawer .v-list__group__items [role="listitem"] .v-list__tile:not(.v-list__tile--active)
{
  opacity: .35 !important;
}

.theme--light .v-navigation-drawer .v-list__group__items [role="listitem"] .v-list__tile:not(.v-list__tile--active)
{
  opacity: .6 !important;
}

.wrap
{
  white-space: normal !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue